import type { Logger } from '@feature-hub/core';
import { createAsyncCarlineFetch } from './getCarlines';
import type { CarlineAvailableStock, Content, I18nMessages } from '../ContentType';
import type { InitialState } from '../FeatureHubAppDefinition';
import { fetchI18nMessages } from '../i18n';
import type { GfaLocaleService, I18NService, OneGraphService } from '../feature-service-types';

let i18nMessages: I18nMessages;

export async function createInitialState(
  oneGraphService: OneGraphService,
  localeService: GfaLocaleService,
  content: Content,
  i18nService: I18NService,
  logger: Logger,
): Promise<InitialState> {
  if (!i18nMessages) {
    i18nMessages = await fetchI18nMessages(localeService, i18nService);
  }

  let availableStock: CarlineAvailableStock | undefined;

  if (
    content.secondaryCta &&
    content.secondaryCta.secondaryOptions === 'vtp' &&
    content.secondaryCta.shopNowCta &&
    content.secondaryCta.shopNowCta.carlineId &&
    content.secondaryCta.shopNowCta.text
  ) {
    const carline = await createAsyncCarlineFetch(
      oneGraphService,
      localeService,
      content.secondaryCta.shopNowCta.carlineId,
      logger,
    );
    if (carline && carline.availableStock) {
      availableStock = {
        name: carline.name,
        newCars: carline.availableStock.newCars ?? undefined,
        usedCars: carline.availableStock.usedCars ?? undefined,
      };
    }

    return {
      carlineAvailableStock: availableStock,
      i18nMessages,
    };
  }
  return {
    i18nMessages,
  };
}

/**
 * Helper function to deserialize the state of the feature app. It converts serialized
 * ReactNodeArray Entries that aren't string to FootnoteReference components
 * @param state
 */

export function deserializeState(state: string): InitialState {
  const props = JSON.parse(state);

  return {
    ...props,
  };
}
